export enum Shape {
  Square = 'square',
  Circle = 'circle',
  Hexagon = 'hexagon',
  Triangle = 'triangle',
  Cluster = 'cluster',
}
